import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { ChevronLeft, Lock } from "lucide-react";
import api from "../lib/api";
import { useT } from "../context/LanguageContext";
import TopBar from "../components/TopBar";

export default function Badges() {
  const navigate = useNavigate();
  const t = useT();
  const [data, setData] = useState(null);

  useEffect(() => { api.get("/badges").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return <div className="space-bg min-h-screen flex items-center justify-center text-white/60">{t("Caricamento...")}</div>;

  return (
    <div className="space-bg min-h-screen pb-20">
      <TopBar />
      <div className="max-w-lg mx-auto px-4 pt-5">
        <button onClick={() => navigate("/dashboard")} className="flex items-center gap-1 text-white/60 bouncy mb-4" data-testid="badges-back-btn"><ChevronLeft size={18} /> {t("Home")}</button>
        <h1 className="font-heading font-black text-3xl tracking-tight flex items-center gap-2 mb-1"><Icons.Medal style={{ color: "var(--gold)" }} /> {t("Traguardi")}</h1>
        <p className="text-white/60 text-sm mb-6 font-num">{data.earned_count}/{data.total} {t("sbloccati")}</p>

        <div className="grid grid-cols-2 gap-4">
          {data.badges.map((b, i) => {
            const BIcon = Icons[b.icon] || Icons.Award;
            return (
              <motion.div key={b.id} initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ delay: i * 0.04 }}
                className="glass rounded-3xl p-5 text-center relative overflow-hidden" data-testid={`badge-${b.id}`}
                style={{ opacity: b.earned ? 1 : 0.55 }}>
                <div className="w-16 h-16 mx-auto rounded-2xl flex items-center justify-center mb-3"
                  style={{ background: b.earned ? `${b.color}22` : "rgba(255,255,255,0.05)", boxShadow: b.earned ? `0 0 18px ${b.color}66` : "none" }}>
                  {b.earned ? <BIcon size={30} style={{ color: b.color }} /> : <Lock size={26} className="text-white/40" />}
                </div>
                <h3 className="font-heading font-bold text-sm tracking-tight leading-tight">{b.name}</h3>
                <p className="text-xs text-white/50 mt-1">{b.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
